import { useEffect } from 'react';
import { apiClient } from '@/shared/api/client';
import { useAuthStore } from '@/shared/stores/auth';

/** פעימת חיוּת — השרת מציג "מחובר" רק אם הייתה פעימה ב-40ש האחרונות. */
export const LIVENESS_MS = 15_000;

/**
 * "מחובר" אמיתי בניטור החי (01/10/2026, בקשת דורון).
 *
 * - ping: פעימה כל 15ש גם בלשונית ברקע (כמו useHeartbeat) — לפרסונות שאין להן
 *   useHeartbeat (מנהל). בנציג useHeartbeat כבר פועם, ולכן ping=false שם.
 * - pagehide: "סגרתי" מיד (fetch keepalive שורד את הסגירה) — המנהל רואה
 *   "לא מחובר" תוך שנייה ולא אחרי 40ש. ברענון הדף הפעימה הראשונה מחזירה את
 *   הסטטוס הקודם (PresenceTracker::restoreAfterReconnect).
 */
export function usePresenceLiveness({ ping }: { ping: boolean }): void {
  useEffect(() => {
    if (!ping) return;
    const beat = () => { void apiClient.post('/agent/settings/heartbeat').catch(() => {}); };
    beat();
    const id = window.setInterval(beat, LIVENESS_MS);
    return () => window.clearInterval(id);
  }, [ping]);

  useEffect(() => {
    const bye = () => sendBye();
    window.addEventListener('pagehide', bye);
    return () => window.removeEventListener('pagehide', bye);
  }, []);
}

export function sendBye(): void {
  try {
    const { token, tenantSlug } = useAuthStore.getState();
    if (!token) return;
    const headers: Record<string, string> = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    if (tenantSlug) headers['X-Tenant-Slug'] = tenantSlug;
    void fetch(`${apiClient.defaults.baseURL ?? ''}/agent/settings/bye`, {
      method: 'POST', keepalive: true, headers, body: '{}',
    }).catch(() => {});
  } catch {
    /* אין fetch — השרת יזהה לבד אחרי 40ש */
  }
}
